import { Controller } from "@hotwired/stimulus"

// Aktualisiert die Filter-Chip-Zeile ("Aktive Filter"), wenn die Job-Liste per
// Turbo-Frame neu geladen wird (Schnellfilter, Sortierung, Pagination). Die Chips
// liegen ausserhalb des jobs-Frames (oberhalb der View-Controls) und werden beim
// Frame-Update serverseitig nicht mitgerendert. Analog zu jobs_count_controller:
// dieses Element wird frisch im Frame gerendert (versteckt) und spiegelt seinen
// Inhalt beim connect in den sichtbaren Slot #job_filter_chips_slot.
export default class extends Controller {
  connect() {
    const slot = document.getElementById("job_filter_chips_slot")
    if (slot) slot.innerHTML = this.element.innerHTML
  }
}
